export function formatTimeSecs(secs: number): string {
  if (secs < 60) return `${secs}s`
  const mins = Math.floor(secs / 60)
  if (mins < 60) return `${mins}m`
  const h = Math.floor(mins / 60)
  const m = mins % 60
  return m === 0 ? `${h}h` : `${h}h ${m}m`
}

export function getTierHeadline(tier: 'A' | 'B' | 'C' | 'needs_support'): { headline: string; sub: string } {
  switch (tier) {
    case 'A':
      return {
        headline: "You're in the top 20%",
        sub: "Keep this up — you're on track for placement readiness by batch end.",
      }
    case 'B':
      return {
        headline: 'Good progress — keep pushing',
        sub: 'A few more weeks of consistent effort puts you in the top tier.',
      }
    case 'C':
      return {
        headline: "You're making progress",
        sub: 'Focus on your weak areas and you will see quick gains.',
      }
    default:
      return {
        headline: "Let's get back on track",
        sub: 'Start with short daily sessions — even 30 minutes makes a difference.',
      }
  }
}

export function getSkillColor(score: number): string {
  if (score >= 70) return '#00b8a9'
  if (score >= 50) return '#6c63ff'
  return '#ef5350'
}
